export default __webpack_public_path__ + "static/media/sandbox-book-new.7e5a0144.png";